import { render, staticRenderFns } from "./BatchEdit.vue?vue&type=template&id=6941be1f&scoped=true&"
import script from "./BatchEdit.vue?vue&type=script&lang=js&"
export * from "./BatchEdit.vue?vue&type=script&lang=js&"
import style0 from "./BatchEdit.vue?vue&type=style&index=0&id=6941be1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6941be1f",
  null
  
)

export default component.exports